import { render, staticRenderFns } from "./OurExcellence.vue?vue&type=template&id=665f230b&"
import script from "./OurExcellence.vue?vue&type=script&lang=js&"
export * from "./OurExcellence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports